import axios, { AxiosRequestConfig } from 'axios';
import config from '.././Config';
import * as search from '../types/Search';
import { headers } from '../types/Headers';
import { documentDefinition } from '../types/Search';
import { field } from '../types/Field';
import { prepareHeaders, getHeaders } from './HeaderService';

const getCounties = async (state: string, token: string, clientId: string) => {
    var result = await axios.request({
        method: 'GET',
        url: config.searchApi.countyUrl + '/' + state,
        headers: getHeaders(token, clientId),
    });

    return result.data;
};

const getStates = async (token: string, clientId: string) => {
    var resultState = await axios.request({
        method: 'GET',
        url: config.searchApi.stateUrl,
        headers: getHeaders(token, clientId),
    });

    return resultState.data;
};

const getSearchBy = async (countyId: string, format: string, token: string, clientId: string) => {
    let callUrl = config.searchApi.searchByUrl + '?countyId=' + countyId;
    if (format !== 'all') {
        callUrl += '&format=' + format;
    }
    var resultSearchBy = await axios.request({
        method: 'GET',
        url: callUrl,
        headers: getHeaders(token, clientId),
    });
    return resultSearchBy.data;
};
const getFormat = async (countyId: string, searchBy: string, token: string, clientId: string) => {
    let callUrl = config.searchApi.formatUrl + '?countyid=' + countyId;
    if (searchBy) {
        callUrl += '&searchBy=' + searchBy;
    }
    let resultFormat = await axios.request({
        method: 'GET',
        url: callUrl,
        headers: getHeaders(token, clientId),
    });

    return resultFormat.data;
};

const getSearchFieldList = async (
    countyId: string,
    searchBy: string,
    format: string,
    token: string,
    clientId: string
) => {
    const callUrl = `${config.searchApi.searchFieldListUrl}?countyId=${countyId}&searchBy=${searchBy}&format=${format}`;
    let results = await axios.request({
        method: 'GET',
        url: callUrl,
        headers: getHeaders(token, clientId),
    });
    return results.data;
};

const getDirectory = async (
    token: string,
    clientId: string,
    path: string,
    pageNumber: number,
    pageSize: number
) => {
    const data = {
        path: path,
        pageNumber: pageNumber,
        pageSize: pageSize,
    };

    let urlSearch = config.searchApi.hierarchy;

    const axconfig = {
        headers: getHeaders(token, clientId),
    };
    return await axios.post(urlSearch, data, axconfig);
};

const getDirectorySearch = async (
    token: string,
    clientId: string,
    path: string,
    searchString: string
) => {
    const data = {
        pathPrefix: path,
        searchString: searchString,
    };

    let urlSearch = config.searchApi.hierarchySearch;

    const axconfig = {
        headers: getHeaders(token, clientId),
    };
    return await axios.post(urlSearch, data, axconfig);
};

const getSearchImages = async (
    req: search.searchRequest,
    token: string,
    clientId: string,
    fields: field[]
) => {
    //TODO: If any of this data is null there is no error checking here

    const params = fields
        ?.filter((f) => f.value !== undefined && f.value !== '')
        .map((field) => {
            return '' + field.name + '=' + field.value;
        })
        .join('&');

    let urlSearch = config.searchApi.searchImageUrl + '?';

    urlSearch += 'searchBy=' + req.searchBy;
    urlSearch += '&countyId=' + req.countyId;

    if (req.format != 'all') {
        urlSearch += '&format=' + req.format;
    }

    urlSearch += '&filter=' + encodeURIComponent(params);

    var resultSearchImage = await axios.request({
        method: 'GET',
        url: encodeURI(urlSearch),
        headers: getHeaders(token, clientId),
    });

    return resultSearchImage;
};

const blobUrlToPrint = (blobUrl: string, fileType: string = 'application/pdf') => {
    var sasURL = blobUrl;
    fetch(sasURL)
        .then((resp) => resp.blob())
        .then((blob) => {
            const url = window.URL.createObjectURL(blob);

            var base64String = '';
            //let dataByte=blobToBase64(blob);
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function () {
                if (reader.result != null) {
                    base64String = reader.result.toString().replace(/^data:.+;base64,/, '');
                }

                let byteCharacters = atob(base64String);

                let byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                let byteArray = new Uint8Array(byteNumbers);
                let file = new Blob([byteArray], {
                    type: 'application/pdf;base64',
                });
                let fileURL = URL.createObjectURL(file);
                window.open(fileURL)?.print();
            };
        })
        .catch(() => alert('oh no! There is an error occured while printing!'));
};

const blobUrlToPrintJPG = (blobUrl: string, fileType: string = 'image/jpeg') => {
    var sasURL = blobUrl;
    fetch(sasURL)
        .then((resp) => resp.blob())
        .then((blob) => {
            const url = window.URL.createObjectURL(blob);

            var base64String = '';
            //let dataByte=blobToBase64(blob);
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function () {
                if (reader.result != null) {
                    base64String = reader.result.toString().replace(/^data:.+;base64,/, '');
                }

                let byteCharacters = atob(base64String);

                let byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                let byteArray = new Uint8Array(byteNumbers);
                let file = new Blob([byteArray], { type: 'image/jpeg;base64' });
                let fileURL = URL.createObjectURL(file);
                window.open(fileURL)?.print();
            };
        })
        .catch(() => alert('oh no! There is an error occured while printing!'));
};

export default {
    getCounties,
    getStates,
    getSearchBy,
    getFormat,
    getSearchFieldList,
    getSearchImages,
    getHeaders,
    prepareHeaders,
    blobUrlToPrint,
    blobUrlToPrintJPG,
    getDirectory,
    getDirectorySearch,
};
